import type { CSSProperties } from "react";

/** 四边间距（px） */
export interface TacticsBoxSpacing {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

/** 策略工具页 UI 配置（按页面元素组织，改这里即可调样式） */
export const TacticsPageUiConfig = {
  /** 策略下拉框 */
  strategySelect: {
    backgroundColor: "#f4f5f9",
    padding: { top: 10, right: 12, bottom: 10, left: 12 },
    margin: { top: 8, right: 0, bottom: 0, left: 10 },
    width: "95%",
    /** 下拉框整体高度（px） */
    height: 35,
    /** 已选文字与下拉选项文字颜色 */
    optionTextColor: "rgba(137, 25, 201, 0.88)",
  },
  /** 个股输入框 */
  stockSearch: {
    backgroundColor: " #f4f5f9",
    focusBackgroundColor: "rgb(255, 240, 240)",
    padding: { top: 8, right: 12, bottom: 8, left: 12 },
    margin: { top: 8, right: 0, bottom: 0, left: 10 },
    /** 输入框区域宽度，如 "100%"、"95%" 或数字（px） */
    width: "95%",
  },
  /** 左侧 Tab 区域 */
  leftTabs: {
    /** 与个股输入框的上间距 */
    marginTop: 12,
    padding: { top: 0, right: 10, bottom: 0, left: 12 },
    /** Tab 标题文字到下方指示下划线的间距 */
    navToContentGap: 4,
    /** Tab 导航区（含下划线）到 Tab 内容区的间距 */
    tabContentGap: 8,
  },
  /** 左侧列表行内文字 */
  stockListRow: {
    stockNameFontSize: 12,
    stockPriceFontSize: 12,
    scoreFontSize: 13,
  },
  /** 整页白卡片容器 */
  pageCard: {
    borderRadius: 10,
    /** 卡片与视口上下间距 */
    marginY: 12,
  },
} as const;

function boxSpacingCss(box: TacticsBoxSpacing): string {
  return `${box.top}px ${box.right}px ${box.bottom}px ${box.left}px`;
}

export function tacticsWidthCss(width: number | string): string {
  return typeof width === "number" ? `${width}px` : width;
}

/** 注入页面根节点 CSS 变量 */
export function tacticsPageCssVars(): CSSProperties {
  const { strategySelect, stockSearch, leftTabs, stockListRow, pageCard } =
    TacticsPageUiConfig;
  return {
    ["--tactics-strategy-select-bg" as string]: strategySelect.backgroundColor,
    ["--tactics-strategy-select-padding" as string]: boxSpacingCss(strategySelect.padding),
    ["--tactics-strategy-select-margin" as string]: boxSpacingCss(strategySelect.margin),
    ["--tactics-strategy-select-width" as string]: tacticsWidthCss(strategySelect.width),
    ["--tactics-strategy-select-height" as string]: `${strategySelect.height}px`,
    ["--tactics-strategy-select-option-color" as string]: strategySelect.optionTextColor,
    ["--tactics-stock-search-margin" as string]: boxSpacingCss(stockSearch.margin),
    ["--tactics-stock-search-padding" as string]: boxSpacingCss(stockSearch.padding),
    ["--tactics-stock-search-width" as string]: tacticsWidthCss(stockSearch.width),
    ["--tactics-left-tabs-margin-top" as string]: `${leftTabs.marginTop}px`,
    ["--tactics-left-tabs-padding" as string]: boxSpacingCss(leftTabs.padding),
    ["--tactics-left-tabs-nav-to-ink-gap" as string]: `${leftTabs.navToContentGap}px`,
    ["--tactics-left-tabs-nav-to-content-gap" as string]: `${leftTabs.tabContentGap}px`,
    ["--tactics-list-stock-name-font-size" as string]: `${stockListRow.stockNameFontSize}px`,
    ["--tactics-list-stock-price-font-size" as string]: `${stockListRow.stockPriceFontSize}px`,
    ["--tactics-list-score-font-size" as string]: `${stockListRow.scoreFontSize}px`,
    ["--tactics-page-card-radius" as string]: `${pageCard.borderRadius}px`,
    ["--tactics-page-card-margin-y" as string]: `${pageCard.marginY}px`,
  };
}
